import { ServiceException } from '@inter-ikea-kompis/exceptions';
import IframeManager from '../../utilities/IframeManager.js';
const COOKIE_NAME = 'ikea_cookieconsent_{countryCode}';
/**
 * This class is used for checking cookie consent.
 */
export default class OneWebCookieConsentService {
    constructor(options) {
        this.iframeManager = null;
        this.endpoint = options.endpoint;
        this.cache = options.cache;
    }
    /**
     * Checks if cookie consent meets a provided level.
     *
     * @param consentLevel Consent level (1-4).
     * @param country Country of the cookie.
     * @returns Promise.
     */
    async hasCookieConsent(consentLevel, country) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.ikea?.cookieConsent?.hasConsent === 'function') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return window.ikea.cookieConsent.hasConsent(consentLevel);
        }
        const cookie = this.getCookie(country);
        if (cookie) {
            return !!Object.values(cookie)[Object.keys(cookie).indexOf(consentLevel.toString())];
        }
        if (this.iframeManager && this.iframeManager.url !== this.endpoint) {
            this.iframeManager.disconnect();
            this.iframeManager = null;
        }
        if (!this.iframeManager) {
            this.iframeManager = new IframeManager(this.endpoint, this.cache);
        }
        const iframe = await this.iframeManager.getIframe();
        if (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        !iframe.contentWindow?.ikea ||
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !iframe.contentWindow.ikea.cookieConsent ||
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !iframe.contentWindow.ikea.cookieConsent.hasConsent) {
            throw new ServiceException('Failed to retrieve cookie consent from iframe. "ikea.cookieConsent.hasConsent()" is not defined.');
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return iframe.contentWindow.ikea.cookieConsent.hasConsent(consentLevel);
    }
    /**
     * @param country Country.
     */
    getCookie(country) {
        const cookieName = COOKIE_NAME.replace('{countryCode}', country.toLowerCase()) + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const existingCookies = decodedCookie.split(';');
        for (let cookie of existingCookies) {
            while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) == 0) {
                return JSON.parse(cookie.substring(cookieName.length, cookie.length));
            }
        }
        return null;
    }
}
//# sourceMappingURL=OneWebCookieConsentService.js.map